namespace RioERP.Web.Enums {
    export enum ProductMappingStatus {
        Inserted = 1,
        Mapped = 2,
        Failed = 3
    }
    Serenity.Decorators.registerEnumType(ProductMappingStatus, 'RioERP.Web.Enums.ProductMappingStatus');
}
